import React from 'react';

import { QBox } from '@captivateiq/quotient';
import { SummaryCard } from '@captivateiq/visualizations';

import type { SummaryCardBlock } from '@captivateiq/assistant/types';

import { chartBlockToSummaryCardProps } from './chartBlockAdapter';

type Props = { block: SummaryCardBlock };

export const SummaryCardBlockRenderer = ({ block }: Props) => (
  <QBox
    sx={{
      backgroundColor: '#fff',
      border: '1px solid',
      borderColor: 'grey.200',
      borderRadius: '8px',
      mb: 2,
      p: 2,
    }}
  >
    <SummaryCard {...chartBlockToSummaryCardProps(block)} />
  </QBox>
);
